import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../Common/Loader";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { generateCustomerApiCredential } from "../../Redux/Slice/Customers/GenerateCustomerApiCredentialSlice";
import CopyIcon from "../../Assets/svgs/CopyIcon";
import CopyTooltipIcon from "../../Common/CopyTooltipIcon";

const CustomerApiKeyPassword = ({
  visible,
  customerId,
  customerEmail,
  apiKeyAndPassword,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [keys, setKeys] = useState({
    apiKey: "",
    password: "",
  });

  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({
    visible: false,
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({
        visible: false,
        message: "",
      });
      if (typeof callback == "function") {
        callback();
      }
    }, 2000);
  };

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message,
    });

    setTimeout(() => {
      setSuccessModal({
        visible: false,
        message: "",
      });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const onCancelClicked = () => {
    navigate(-1);
  };
  const handleSubmit = async () => {
    setConfirmModel(false);
    setIsLoading(true);
    const body = {
      customerId: customerId,
      email: customerEmail,
    };
    const result = await dispatch(generateCustomerApiCredential(body));
    if (
      generateCustomerApiCredential.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setKeys({
        apiKey: result?.payload?.data?.apiKey,
        password: result?.payload?.data?.apiPassword,
      });
      showSuccessMessage("Api key generated successfully.");
    } else {
      setIsLoading(false);
      showErrorMessage(
        result?.payload?.error?.message
          ? result?.payload?.error?.message
          : "Something went wrong."
      );
    }
  };

  const handleUpdateClicked = () => {
    if (keys?.apiKey && keys?.password) {
      setConfirmModel(true);
    } else {
      handleSubmit();
    }
  };

  const handelCancel = () => {
    setConfirmModel(false);
  };

  useEffect(() => {
    if (apiKeyAndPassword) {
      setKeys({
        apiKey: apiKeyAndPassword?.apiKey ?? "",
        password: apiKeyAndPassword?.apiSecret ?? "",
      });
    }
  }, [apiKeyAndPassword]);

  return (
    <div
      className={
        visible
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      <div className="page__body">
        {isLoading ? <Loader /> : ""}
        {errorModal.visible ? <ErrorModel message={errorModal.message} /> : ""}
        {successModal.visible ? (
          <SuccessModel message={successModal.message} />
        ) : (
          ""
        )}
        {confirmModel ? (
          <ConfirmModel
            onAccept={handleSubmit}
            yes={"Yes"}
            no={"No"}
            onReject={handelCancel}
            title="Regenrate API Key & Password"
            message="Are you sure you want to regenrate API Key & Password?"
          />
        ) : (
          ""
        )}
        <div className="details">
          <div className="form">
            <section className="form__section">
              <h1 className="form__section__title">
                Generate API Key & Password
              </h1>
              {keys?.apiKey && keys?.password ? (
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="apiKey" className="form__label">
                        API Key
                      </label>
                      <div className="form__groupField form__groupField--disabled">
                        <input
                          type="password"
                          id="apiKey"
                          name="apiKey"
                          value={keys.apiKey}
                          disabled
                          className="form__input form__input--sm"
                          placeholder="API Key"
                          maxLength={16}
                        />
                        <CopyTooltipIcon text={keys.apiKey} />
                      </div>
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="password" className="form__label">
                        Password
                      </label>
                      <div className="form__groupField form__groupField--disabled">
                        <input
                          type="password"
                          id="password"
                          name="password"
                          value={keys.password}
                          disabled
                          className="form__input form__input--sm"
                          placeholder="Password"
                          maxLength={16}
                        />
                        <CopyTooltipIcon text={keys.password} />
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="btn__group">
                <button
                  className="btn btn__white"
                  onClick={onCancelClicked}
                  type="button"
                >
                  Cancel
                </button>
                <button
                  className="btn btn__primary"
                  type="submit"
                  onClick={handleUpdateClicked}
                >
                  {keys?.apiKey && keys?.password
                    ? "Regenerate Key"
                    : "Create Key"}
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerApiKeyPassword;
